// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"7117d380","365":"5b11a495","433":"cad63971","810":"5b11a495"}[chunkId] + ".chunk.css";
};